var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetroSalesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 7.875H10.5V5.25H14V14H13.125V6.125H11.375V7.875ZM4.375 4.375V8.75H5.25V2.625H6.125V0H8.4175L9.625 1.63363V7.875H8.75V1.92237L7.97563 0.875H7V3.5H6.125V14H0V6.125H0.875V4.375H4.375ZM2.625 9.625V8.75H3.5V5.25H1.75V7H0.875V13.125H5.25V9.625H2.625ZM8.75 8.75H12.25V14H7V10.5H8.75V8.75ZM9.625 9.625V11.375H7.875V13.125H11.375V9.625H9.625ZM2.625 11.375H4.375V10.5H2.625V11.375Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetroSalesIcon);
export default __webpack_public_path__ + "static/media/metro-sales-icon.19ce63986b54d0d03b524caa8ac5458f.svg";
export { ForwardRef as ReactComponent };